import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { Text } from 'Packages/FacetDesign/Components/Text';
import { FDBodyText, FDHeadlineText } from '@facet-wealth/design';

export const nonHYAMetaOverrideSet = buildFacetDesignOverride()
  .nameOverride('title', {
    _component: () => Text,
    _customProps: { Component: FDHeadlineText, size: 'sm' },
  }, overrideReadOnly)
  .nameOverride('description', {
    _component: () => Text,
    _customProps: { Component: FDBodyText, size: 'md' },
  }, overrideReadOnly);
